import { get as _get, isEmpty as _isEmpty } from "lodash-es";
import React, { useMemo, useState } from "react";
import dayjs from "../../utils/dayjs";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import tw from "tailwind-styled-components";

import { createCircle, deleteCircle, addHumans } from "../../actions/circles";
import AddCircleModal from "./AddCircleModal";
import EmptyResult from "../../components/EmptyResult";
import Circle from "./Circle";
import { escapeRegExp } from "../../utils";
import Input from "../../components/Input";

const CirclesWrapper = tw.div`
min-w-0
w-full
lg:flex-1
pb-16
lg:pb-0
`;

const CirclesListWrapper = tw.div`
bg-white
shadow
sm:rounded-md w-full
h-full
`;

const CirclesList = tw.ul`
divide-y 
divide-gray-200 
`;

function Circles(props) {
  const { location, circles, deleteCircle, addHumans } = props;
  const [searchText, setSearchText] = useState(
    _get(location, "state.query", "")
  );

  const visibleCircles = useMemo(() => {
    let filteredCircles = circles;

    if (searchText) {
      const r = new RegExp(escapeRegExp(searchText), "ig");
      filteredCircles = circles.filter((c) => r.test(c.name));
    }

    return filteredCircles.sort((a, b) =>
      dayjs.utc(b.modifiedAt).diff(dayjs.utc(a.modifiedAt))
    );
  }, [circles, searchText]);

  return (
    <CirclesWrapper>
      <div className="flex justify-between items-center mt-3">
        <Input
          className="m-1 py-1 h-10 w-1/2"
          placeholder="Search circles"
          onChange={(e) => setSearchText(e.target.value)}
          value={searchText}
          type="text"
        />
        <div>
          <AddCircleModal {...props} />
        </div>
      </div>
      <div className="pb-7 lg:py-4 p-0.5">
        {_isEmpty(visibleCircles) ? (
          <EmptyResult>
            {searchText.length
              ? "None of your circles match those search terms"
              : "You haven't created any Circles yet"}
          </EmptyResult>
        ) : (
          <CirclesListWrapper>
            <CirclesList>
              {visibleCircles.map((circle) => (
                <Circle
                  addHumans={addHumans}
                  key={circle.id}
                  circleData={circle}
                  onRemoveCircle={() => {
                    if (
                      window.confirm(
                        "Are you sure you want to remove this circle?"
                      )
                    ) {
                      deleteCircle(circle.id);
                    }
                  }}
                />
              ))}
            </CirclesList>
          </CirclesListWrapper>
        )}
      </div>
    </CirclesWrapper>
  );
}

Circles.propTypes = {
  location: PropTypes.object.isRequired,
  humans: PropTypes.array.isRequired,
  circles: PropTypes.array.isRequired,
  deleteCircle: PropTypes.func.isRequired,
  addHumans: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  humans: state.humans,
  circles: state.circles,
});

const mapDispatchToProps = (dispatch) => ({
  deleteCircle: (circleId) => dispatch(deleteCircle(circleId)),
  createCircle: (name) => dispatch(createCircle(name)),
  addHumans: (humanIds, circleId) => dispatch(addHumans(humanIds, circleId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Circles);
